"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLoaders = void 0;
var _auth = require("@ori/auth");
var _LibsLoader = require("./LibsLoader");
var _SpasLoader = require("./SpasLoader");
var _jsxRuntime = require("react/jsx-runtime");
const AppLoaders = ({
  customerId = _auth.NOT_LOGGED_IN_USER_ID,
  environment,
  libs,
  spas,
  token = ''
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_auth.UniversalTokenProvider, {
  customerId: customerId,
  initialToken: token,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LibsLoader.LibsLoader, {
    libs: libs
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SpasLoader.SpasLoader, {
    environment: environment,
    spas: spas
  })]
});
exports.AppLoaders = AppLoaders;
